import { useTranslation } from 'react-i18next';

export default function Testimonials() {
  const { t } = useTranslation();

  const testimonials = [
    {
      name: t('testimonials.person1.name'),
      role: t('testimonials.person1.role'),
      company: t('testimonials.person1.company'),
      content: t('testimonials.person1.content')
    },
    {
      name: t('testimonials.person2.name'),
      role: t('testimonials.person2.role'),
      company: t('testimonials.person2.company'),
      content: t('testimonials.person2.content')
    },
    {
      name: t('testimonials.person3.name'),
      role: t('testimonials.person3.role'),
      company: t('testimonials.person3.company'),
      content: t('testimonials.person3.content')
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
          {t('testimonials.title')}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gray-50 p-6 rounded-lg"
            >
              <p className="text-gray-600 mb-4 italic">"{testimonial.content}"</p>
              <div>
                <p className="font-semibold text-gray-900">{testimonial.name}</p>
                <p className="text-gray-500">{testimonial.role}</p>
                <p className="text-gray-500 italic">{testimonial.company}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
